// 全局按钮防重复点击。首次点击立即执行，同一按钮在等待时间内的重复点击会被忽略。
const DEFAULT_WAIT = 800;
const BUTTON_SELECTOR = [
    'button',
    'input[type="button"]',
    'input[type="submit"]',
    'input[type="reset"]',
    '[role="button"]',
    '.el-button',
    '.btn',
    '.btn-div',
    '.add-btn',
    '.add-button',
    '.archives-btn',
    '.bar-code-top-btn',
    '.btn-css',
    '.btn-css-green',
    '.course-img-btn-sty',
    '.edit-package-btn',
    '.el-tab-pane-btn',
    '.endProjectBtn',
    '.export-btn',
    '.finish-btn',
    '.history-btn-sty',
    '.home-title-button',
    '.item-button',
    '.label-bar-btn',
    '.matching-btn',
    '.operate-btn',
    '.outline-btn',
    '.print-btn',
    '.project-btn',
    '.project-btn-left',
    '.project-btn-right',
    '.reset-btn',
    '.search-btn',
    '.tab-btn',
    '.timetable-btn',
    '.upload-btn',
    '.upload-btn-course',
    '.import',
    'a.delete',
    '.download-text',
    '.add-class',
    '.item-bottom-left',
    '.item-bottom-right'
].join(',');

const lastClickTimes = typeof WeakMap === 'function' ? new WeakMap() : null;

function matches(element, selector) {
    const matcher = element.matches ||
        element.msMatchesSelector ||
        element.webkitMatchesSelector;

    return matcher ? matcher.call(element, selector) : false;
}

function findButton(element) {
    while (element && element !== document) {
        if (element.nodeType === 1 && matches(element, BUTTON_SELECTOR)) {
            return element;
        }
        element = element.parentNode;
    }
    return null;
}

function isDisabled(element) {
    return element.disabled ||
        element.getAttribute('aria-disabled') === 'true' ||
        matches(element, '.is-disabled,.disabled');
}

function getWait(element) {
    if (!element.hasAttribute('data-click-debounce')) {
        return DEFAULT_WAIT;
    }

    const configuredWait = Number(element.getAttribute('data-click-debounce'));
    return configuredWait >= 0 ? configuredWait : DEFAULT_WAIT;
}

function getLastClickTime(element) {
    if (lastClickTimes) {
        return lastClickTimes.get(element) || 0;
    }
    return element.__buttonDebounceLastClick || 0;
}

function setLastClickTime(element, time) {
    if (lastClickTimes) {
        lastClickTimes.set(element, time);
        return;
    }
    element.__buttonDebounceLastClick = time;
}

function stopRepeatedClick(event) {
    const button = findButton(event.target);

    if (!button || isDisabled(button) || button.hasAttribute('data-allow-rapid-click')) {
        return;
    }

    const now = Date.now();
    const wait = getWait(button);
    const lastClickTime = getLastClickTime(button);

    if (now - lastClickTime < wait) {
        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) {
            event.stopImmediatePropagation();
        }
        return;
    }

    setLastClickTime(button, now);
}

export function installButtonDebounce() {
    if (typeof document === 'undefined' || document.__buttonDebounceInstalled) {
        return;
    }

    document.addEventListener('click', stopRepeatedClick, true);
    document.__buttonDebounceInstalled = true;
}



// WEBPACK FOOTER //
// ./src/utils/button-debounce.js